import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { saveAs } from 'file-saver';
import { CrudService } from '@services/laravel/crud.service';
import { ToastrService } from 'ngx-toastr';
import { NgClass, DatePipe } from '@angular/common';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { MatTable, MatColumnDef, MatCellDef, MatCell, MatRowDef, MatRow } from '@angular/material/table';
import { MatIcon } from '@angular/material/icon';

@Component({
    standalone: true,
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css'],
    imports: [NgClass, MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatTable, MatColumnDef, MatCellDef, MatCell, MatIcon, MatRowDef, MatRow, MatExpansionPanelDescription, DatePipe]
})
export class MessageComponent implements OnChanges {
  @Input() isParent;
  @Input() showSender;
  @Input() recipients;
  @Input() message;
  @Output() openRecipientList: EventEmitter<any> = new EventEmitter();
  public storageRoute: any = 'storage/message-attachments';
  displayedColumns: string[] = ['description', 'actions'];
  constructor(private _crud: CrudService, public toastr: ToastrService, ) { }

  ngOnChanges() {

  }

  downloadFile(attachment) {
    attachment.downloading = true;
    this._crud.downloadFileFromUrl(this.storageRoute + '/' + attachment.hashname, attachment.filename).then(response => {
      saveAs(response, attachment.filename);
      attachment.downloading = false;
    }).catch(err => {
      attachment.downloading = false;
      this.toastr.error('Erro ao baixar anexo.', 'Erro!');
    });
  }

  viewRecipientList() {
    this.openRecipientList.emit();
  }
}
